import React from 'react';
import { useUser } from '../Providers/UserProvider';
import useSWR from 'swr';
import { getProjectPage } from '../../utils/woorankApi';
import {
  BrowserRouter as Router,
  useParams
} from 'react-router-dom';
import {
  Button,
  Layout,
  Card,
  Page,
  SkeletonBodyText,
  SkeletonThumbnail,
  Stack
} from '@shopify/polaris';
import ReviewContainer from '@hydra/routes/review/components/ReviewContainer';
import { useI18n } from '@hydra/common/customHooks';
import { getReviewStructure } from '@hydra/utils/reviewStructureHelper';
import { ReviewDashboardDisplayLoadingState } from '@hydra/routes/shopify/components/Review/Banner';
import { makeStyles } from '@material-ui/core/styles';
import { shopifyRelativeUrl } from '../../utils/url';
const useStyles = makeStyles(theme => ({
  buttonContainer: { padding: theme.spacing(0, 2) }
}));
function ReviewDisplay ({ reviewData } : { reviewData: any}) {
  const { translate } = useI18n();
  const classes = useStyles();
  const containerData = {
    review: reviewData,
    reviewStructure: getReviewStructure({ criteria: reviewData.criteria }),
    url: reviewData.url,
    pdfTemplates: [] as any,
    isProject: true,
    gaUserInfo: {
      authenticated: false
    },
    projectCriteriaId: []
  };
  const backToHomeUrl = shopifyRelativeUrl('/shopify', window.location);
  return (
    <>
      <div className={classes.buttonContainer}>
        <Button plain monochrome url={backToHomeUrl} removeUnderline>
          {translate('shopify_back_to_homepage')}
        </Button>
      </div>
      <ReviewContainer
        data={containerData}
        showHeader={false}
        fullWidth
        hideFooter
        isShopify
      />
    </>
  );
}

function FullReviewLoadingState () {
  return (
    <Layout>
      <Layout.Section>
        <Card>
          <Card.Section>
            <ReviewDashboardDisplayLoadingState />
          </Card.Section>
          <Card.Section>
            <Layout>
              <Layout.Section oneThird>
                <Stack>
                  <SkeletonThumbnail size='extraSmall' />
                  <SkeletonThumbnail size='extraSmall' />
                  <SkeletonThumbnail size='extraSmall' />
                </Stack>
              </Layout.Section>
            </Layout>
          </Card.Section>
        </Card>
        {
          new Array(10).fill(undefined).map(index =>
            <Card sectioned key={index}>
              <SkeletonBodyText lines={Math.ceil(Math.random() * 10)} />
            </Card>)
        }
      </Layout.Section>
      <Layout.Section secondary>
        <SkeletonBodyText lines={10} />
      </Layout.Section>
    </Layout>
  );
}

export function FullReview () {
  const { url }: { url?: string } = useParams<{url: string}>();
  const { loading: userLoading, user } = useUser();
  const { data: reviewData, error } = useSWR(
    user?.apiKey && url ? `/woorank-api/review/${url}` : null,
    () => getProjectPage(url as string, user!.apiKey)
  );
  const loading = userLoading || reviewData === undefined;
  return (
    <Page fullWidth>
      {
        loading
          ? <FullReviewLoadingState />
          : reviewData === null
            ? <>Something went wrong</>
            : <ReviewDisplay reviewData={reviewData} />
      }
    </Page>
  );
}
